import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export default function FamilyDetailsSection({
  familyDetail,
  handleInputChange,
  deleteFamily,
  AddFamilyMember,
  errors,
  preventLeadingSpace,
}) {
  return (
    <>
      {familyDetail.map((member, index) => (
        <div key={index} className="border p-3 mb-3 rounded position-relative">
          {familyDetail.length > 1 && (
            <span
              onClick={() => deleteFamily(index)}
              //   type = "button"
              style={{
                // position: "absolute",
                float: "right",
                top: "10px",
                right: "10px",
                cursor: "pointer",
                color: "red",
                fontSize: "1.2rem",
              }}
              title="Remove Family Member"
            >
              <i className="fas fa-trash"></i>
            </span>
          )}
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ color: "#334d6e" }}>
                  Member Name
                </Form.Label>
                <Form.Control
                  type="text"
                  className="  text-muted"
                  name="member_name"
                  value={member.member_name}
                  onChange={(e) => handleInputChange(e, "Family", index)}
                  onKeyDown={preventLeadingSpace}
                  isInvalid={!!errors[`familyDetail_member_name_${index}`]}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`familyDetail_member_name_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ color: "#334d6e" }}>Relation</Form.Label>
                <Form.Control
                  type="text"
                  className="  text-muted"
                  name="relation"
                  value={member.relation}
                  onChange={(e) => handleInputChange(e, "Family", index)}
                  onKeyDown={preventLeadingSpace}
                  isInvalid={!!errors[`familyDetail_relation_${index}`]}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`familyDetail_relation_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ color: "#334d6e" }}>
                  Date Of Birth
                </Form.Label>
                <Form.Control
                  className="  text-muted"
                  type="date"
                  name="member_dob"
                  value={
                    member.member_dob
                      ? new Date(member.member_dob).toISOString().slice(0, 10)
                      : ""
                  }
                  onChange={(e) => handleInputChange(e, "Family", index)}
                  isInvalid={!!errors[`familyDetail_member_dob_${index}`]}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`familyDetail_member_dob_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ color: "#334d6e" }}>Occupation</Form.Label>
                <Form.Control
                  className="  text-muted"
                  type="text"
                  name="occupation"
                  value={member.occupation}
                  onChange={(e) => handleInputChange(e, "Family", index)}
                  onKeyDown={preventLeadingSpace}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ color: "#334d6e" }}>
                  Contact Number
                </Form.Label>
                <Form.Control
                  className="  text-muted"
                  type="text"
                  maxLength="10"
                  name="member_contact_number"
                  value={member.member_contact_number}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");
                    handleInputChange(
                      {
                        target: {
                          name: "member_contact_number",
                          value: numericValue,
                        },
                      },
                      "Family",
                      index
                    );
                  }}
                  onKeyDown={preventLeadingSpace}
                  isInvalid={
                    !!errors[`familyDetail_member_contact_number_${index}`]
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`familyDetail_member_contact_number_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}
      <Button variant="primary" onClick={AddFamilyMember}>
        Add Family Member
      </Button>
    </>
  );
}
